module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kj-Ld.0aa5825c.png";